export const TESTIDS = {
  // Auth
  AUTH_EMAIL_INPUT: 'auth-email-input',
  AUTH_PASSWORD_INPUT: 'auth-password-input',
  AUTH_NAME_INPUT: 'auth-name-input',
  AUTH_LOGIN_BUTTON: 'auth-login-button',
  AUTH_REGISTER_BUTTON: 'auth-register-button',
  AUTH_TOGGLE_MODE: 'auth-toggle-mode',

  // Dashboard
  DASHBOARD_CREATE_WORKSPACE: 'dashboard-create-workspace-button',
  WORKSPACE_CARD: 'workspace-card',
  
  // Workspace
  WORKSPACE_NAME_INPUT: 'workspace-name-input',
  WORKSPACE_DESCRIPTION_INPUT: 'workspace-description-input',
  WORKSPACE_SUBMIT: 'workspace-submit-button',
  WORKSPACE_TAB_OVERVIEW: 'workspace-tab-overview',
  WORKSPACE_TAB_MEMORY: 'workspace-tab-memory',
  WORKSPACE_TAB_CONFIG: 'workspace-tab-config',
  WORKSPACE_TAB_DEPLOY: 'workspace-tab-deploy',

  // Mission
  MISSION_CREATE_BUTTON: 'mission-create-button',
  MISSION_OBJECTIVE_INPUT: 'mission-objective-input',
  MISSION_TYPE_SELECT: 'mission-type-select',
  MISSION_SUBMIT: 'mission-submit-button',
  MISSION_CARD: 'mission-card',

  // Memory
  MEMORY_CREATE_BUTTON: 'memory-create-button',
  MEMORY_TITLE_INPUT: 'memory-title-input',
  MEMORY_CONTENT_INPUT: 'memory-content-input',
  MEMORY_TYPE_SELECT: 'memory-type-select',
  MEMORY_CARD: 'memory-card',

  // Files
  FILE_UPLOAD_BUTTON: 'file-upload-button',
  FILE_UPLOAD_INPUT: 'file-upload-input',

  // Navigation
  NAV_LOGO: 'nav-logo',
  NAV_WORKSPACES: 'nav-workspaces',
  NAV_MISSIONS: 'nav-missions',
  NAV_PROFILE: 'nav-profile',
  NAV_LOGOUT: 'nav-logout',
};

export default TESTIDS;
